// extracted by mini-css-extract-plugin
export default {"results":"Results_results__N-veT"};